export function getParams () {
    const querySearchParams = new URLSearchParams(window.location.search);
    const queryHashParams = new URLSearchParams(window.location.hash.indexOf('?') !== -1 ? window.location.hash.split('?')[1] : window.location.hash);
    const queryParams = new URLSearchParams();
    for (const source of [querySearchParams, queryHashParams]) {
        for (const [key, value] of source.entries()) {
            queryParams.set(key, value);
        }
    }
    return queryParams;
};
